import React from 'react'
import IconInsuranceAccepted from '@/components/IconInsuranceAccepted'

function InsuranceAcceptedDisplay(): JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <div className="text-green-500">
        <IconInsuranceAccepted />
      </div>
      <div className="text-xs text-gray-800 font-semibold">
        Insurance Accepted
      </div>
    </div>
  )
}

export default InsuranceAcceptedDisplay
